<style src="./ManipulateMinimum.scss" lang="scss"></style>
<template>
  <section class="manipulate-minimum">
    <div class="label">
      <span class="cp1-p5">
        Percentual Mínimo
      </span>
    </div>
    <form
      @submit.prevent="openModalConfirm"
      class="form cp1-input-group">
      <button
        class="appendbutton">
        <icon-right-arrow />
      </button>
      <input
        type="text"
        v-model="addPercentual"
        placeholder="25"
        class="appendtextbox" />
    </form>

    <modal
      transition="nice-modal-fade"
      name="_modalConfirmAddMinimumPerc"
      width="500px"
      height="auto">
      <aside class="modal-confirm">
        <icon-danger class="illustration" />
        <p class="description">
          Essa ação irá aplicar <strong>{{addPercentual}}%</strong> em todos os valores da coluna <strong>MÍNIMO</strong>. Tem certeza que deseja continuar?
        </p>

        <section class="cmdcancel">
          <button
            type="button"
            @click="cancelApply"
            class="btn-ghost">Cancelar ação</button>
        </section>
        <form
          @submit.prevent="applyPercentual"
          class="cmdapply">

          <button-submit
            label="Sim, pode alterar os valores"
            :state="commands.submitState"
            :icon-save="commands.saveIcon" />
        </form>
      </aside>
    </modal>
  </section>
</template>

<script>
import { ButtonSubmit } from '@/components/primitives'
import { IconRightArrow, IconDanger, IconSave } from '@/components/primitives/icons'
import CalculatePercentualByField from '../../helpers/CalculatePercentualByField'

export default {
  name: 'ManipulateMinimum',
  components: {
    ButtonSubmit,
    IconRightArrow,
    IconDanger,
    IconSave
  },
  data: () => ({
    addPercentual: 20,
    commands: {
      submitState: 'REPOSE',
      saveIcon: IconSave
    }
  }),
  methods: {
    cancelApply () {
      this.$modal.hide('modalConfirmAddMinimumPerc')
    },
    openModalConfirm () {
      this.$modal.show('modalConfirmAddMinimumPerc')
    },
    async applyPercentual () {
      this.commands.submitState = 'WAIT'

      const calculateSalePerc = CalculatePercentualByField('minimum', this.addPercentual)
      const payload = this.$store.getters['ItemPricing/GET_ALL_LIST']
        .map(calculateSalePerc)
        .filter(i => !!i)

      this.$store.commit('ItemPricing/SET_ALL_SALES_VALUE', {
        field: 'minimum',
        percentual: this.addPercentual,
        items: payload
      })

      try {
        await this.$store.dispatch('ItemPricing/UPDATE_SALE_LIST', { payload })

        this.$toasted.success('Atualização salva com sucesso!')
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.commands.submitState = 'REPOSE'
        this.$modal.hide('modalConfirmAddMinimumPerc')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/manipulate-minimum/ManipulateMinimum.vue